import React from 'react'
import './Piffa.css'

function Piffa() {
  return (
    <div className="main-piffa-container">
      {/* Hero section with background image and overlay */}
      <div className="piffa-hero">
        <div className="piffa-overlay">
          <h1>PIFFA</h1>
        </div>
      </div>
      
      {/* White gap */}
      <div className="white-gap"></div>
      
      {/* Content section with PIFFA information */}
      <div className="piffa-content">
        <h2>PIFFA</h2>
        <p className="piffa-highlight">CENTREX Marine Services is a member of PIATA.</p>
        
        <div className="piffa-section">
          <h3>The Pakistan International Freight Forwarders Association</h3>
          <p>PIFFA is having more than 850+ Freight Forwarding companies as members, aims to provide effective representation and support for Pakistan freight services industry to observe the highest standards of professional competence.</p>
        </div>
        
        <div className="piffa-section">
          <p>This website aims to promote the Association and its Members, as well as being a source of information on a wide range of subjects to both Members and those who wish to engage with the business of freight forwarding.</p>
        </div>
        
        <div className="piffa-link">
          <a href="https://www.piffapk.com/" target="_blank" rel="noopener noreferrer">
            Visit PIFFA Official Website
          </a>
        </div>
      </div>
    </div>
  )
}

export default Piffa
    